import { z } from 'zod';
import { BaseTemplateSchema } from './base.js';
/** @deprecated */
export const TimelineTemplateTypeSchema = z.literal('templates:types:timeline');
/** @deprecated */
export const TimelineInstructionOptionsSchema = z.object({
    from: z.string().array().optional(),
    label: z.string(),
    noRepeat: z.boolean().optional(),
    on: z.string().array().optional(),
    overridesOrder: z.boolean().optional(),
    order: z.number().optional(),
    requires: z.string().array().optional(),
    shouldNotSupersede: z.string().array().optional(),
    to: z.array(z.object({
        on: z.string().array(),
        key: z.string().or(z.undefined()),
        requires: z.string().array().optional(),
    })),
    unique: z.boolean().optional(),
});
/** @deprecated */
export const TimelineInstructionTemplateSchema = z.record(z.string(), TimelineInstructionOptionsSchema);
/** @deprecated */
export const TimelineTemplateSchema = BaseTemplateSchema.merge(z.object({
    type: TimelineTemplateTypeSchema,
    instructionTemplate: TimelineInstructionTemplateSchema,
    timelineType: z.string(),
    isLinear: z.boolean().optional(),
}));
/** @deprecated */
export const DefaultTimelineTemplateSchema = TimelineTemplateSchema.omit({
    createdOn: true,
    id: true,
}).merge(z.object({
    createdOn: TimelineTemplateSchema.shape.createdOn.optional(),
    id: TimelineTemplateSchema.shape.id.optional(),
}));
// Util method for timeline service to validate specific templates
/** @deprecated */
export const makeTimelineInstructionTemplateSchema = (eventType, pointType) => z.partialRecord(pointType, z.object({
    from: pointType.array().optional(),
    label: z.string(),
    on: eventType.array().optional(),
    order: z.number().optional(),
    overridesOrder: z.boolean().optional(),
    noRepeat: z.boolean().optional(),
    requires: pointType.array().optional(),
    shouldNotSupersede: pointType.array().optional(),
    to: z.array(z.object({
        on: eventType.array(),
        key: pointType.or(z.undefined()),
        requires: pointType.array().optional(),
    })),
    unique: z.boolean().optional(),
}));
